import React from 'react';
import { RefreshCw } from 'lucide-react';

const statCardClasses =
  'flex-1 min-w-[70px] bg-white/[0.02] backdrop-blur-sm border border-white/[0.05] rounded px-3 py-2.5';

const FootballMobileControlBar = ({
  t,
  onRefresh,
  loading,
  totals = { total: 0, live: 0, upcoming: 0, finished: 0 }
}) => {
  const summaryCards = [
    { label: t('Total'), value: totals.total, tone: 'text-white/80' },
    { label: t('Live'), value: totals.live, tone: 'text-emerald-400/80' },
    { label: t('Upcoming'), value: totals.upcoming, tone: 'text-violet-400/80' },
    { label: t('Finished'), value: totals.finished, tone: 'text-white/60' }
  ];

  return (
    <div className="flex flex-wrap gap-2">
      <button
        type="button"
        onClick={onRefresh}
        disabled={loading}
        className="px-3 py-2 bg-white/[0.02] backdrop-blur-sm border border-white/[0.05] rounded-md text-[11px] text-white/60 uppercase tracking-wider hover:bg-white/[0.03] hover:border-white/[0.08] hover:text-white/80 transition-all duration-150 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-1.5"
      >
        <RefreshCw size={14} className={loading ? 'animate-spin' : ''} />
        <span>{loading ? t('Loading...') : t('Refresh')}</span>
      </button>

      <div className="grid grid-cols-4 gap-2">
        {summaryCards.map((card) => (
          <div key={card.label} className={statCardClasses}>
            <span className="block text-[10px] text-white/30 uppercase tracking-wider mb-1">
              {card.label}
            </span>
            <span className={`font-mono text-lg ${card.tone}`}>
              {card.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FootballMobileControlBar;
